import { render, staticRenderFns } from "./MerchantListDetail.vue?vue&type=template&id=880cfc52"
import script from "./MerchantListDetail.vue?vue&type=script&lang=js"
export * from "./MerchantListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports